export default "__VITE_ASSET__DXcEVKrn__"